import { Card, Divider } from 'antd';
import React, { memo } from 'react';
import { Props } from './types';
import { Container, InfoContainer, Key, Value } from './styles';
import { Skeleton } from 'antd';
import { colorIconConversation } from '../../../../Utils';
import {
  UserOutlined,
  CopyOutlined,
  MessageOutlined,
  CalendarOutlined,
  AlertOutlined,
  BorderlessTableOutlined,
  EnvironmentOutlined,
  UsergroupAddOutlined,
  ShopOutlined,
} from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../store';
import mask, { maskCapitalized } from '../../../../../../utils/mask';
import moment from 'moment';
import SelectAtendente from '../../../../components/SelectAtendente';
import SelectSeverity from '../../../../components/SelectSeveridade';
import SelectStatus from '../../../../components/SelectStatus';
import SelectDepartamento from '../../../../components/SelectDepartamento';
import { ROLE } from 'utils/roles';

const App: React.FC<Props> = () => {
  const perfil = useSelector((state: ApplicationState) => state.auth.user?.perfil);
  const showInfo = perfil && [ROLE.ADMINISTRADOR, ROLE.ANALISTACD].includes(perfil);
  const load = useSelector((state: ApplicationState) => state.Ocorrencia.loading);
  const [showDepartamento, setShowDepartamento] = React.useState<boolean>(false);
  const ocorrencia: any = useSelector(
    (state: ApplicationState) => state.Ocorrencia.data['ocorrencia']
  );
  const sizeIcon = 18;
  let colorIcon = colorIconConversation(ocorrencia?.urgencia);

  function formatCyte(cidade: string) {
    const city = cidade?.split(' - ');
    return maskCapitalized(city[0]) + ' - ' + city[1]?.toUpperCase();
  }

  return (
    <Container>
      {!load ? (
        <Card
          title={
            <Divider orientation="left" className="themeSLA">
              Detalhes do atendimento
            </Divider>
          }
        >
          <InfoContainer>
            <Key className="themeSLA">
              <UserOutlined style={{ color: colorIcon, fontSize: sizeIcon }} /> Atendente:
            </Key>

            <Value
              className="themeSLA"
              style={{
                display: 'inline-block',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                direction: 'ltr',
              }}
            >
              {showInfo ? (
                <SelectAtendente
                  protocolo={ocorrencia?.protocolo}
                  currentAttendant={ocorrencia?.atendente}
                />
              ) : (
                <>
                  {ocorrencia?.atendente
                    ? mask('camelCase', ocorrencia?.atendente)
                    : 'Não informado'}
                </>
              )}
            </Value>
          </InfoContainer>

          <InfoContainer>
            <Key className="themeSLA">
              <BorderlessTableOutlined style={{ color: colorIcon, fontSize: sizeIcon }} />{' '}
              Severidade:
            </Key>

            <Value className="themeSLA">
              <SelectSeverity currentSeverity={ocorrencia?.urgencia} />
            </Value>
          </InfoContainer>

          {showInfo && (
            <InfoContainer>
              <Key className="themeSLA">
                <AlertOutlined style={{ color: colorIcon, fontSize: sizeIcon }} /> Status:
              </Key>

              <Value className="themeSLA">
                <SelectStatus
                  protocolo={ocorrencia?.protocolo}
                  status={ocorrencia?.status}
                  setShowDepartamento={setShowDepartamento}
                />
              </Value>
            </InfoContainer>
          )}

          {(showInfo && showDepartamento) ||
          (showInfo && ocorrencia?.departamento && ocorrencia?.status === 'ARI') ? (
            <InfoContainer>
              <Key className="themeSLA">
                <UsergroupAddOutlined style={{ color: colorIcon, fontSize: sizeIcon }} />{' '}
                Departamento:
              </Key>

              <Value className="themeSLA">
                <SelectDepartamento currentDepartamento={ocorrencia?.departamento} />
              </Value>
            </InfoContainer>
          ) : (
            ''
          )}

          <InfoContainer>
            <Key className="themeSLA">
              <ShopOutlined style={{ color: colorIcon, fontSize: sizeIcon }} /> Centro de
              distribuição:
            </Key>

            <Value className="themeSLA">
              {ocorrencia?.centrodistribuicao
                ? maskCapitalized(ocorrencia?.centrodistribuicao)
                : 'Não informado'}
            </Value>
          </InfoContainer>

          <InfoContainer>
            <Key className="themeSLA">
              <UserOutlined style={{ color: colorIcon, fontSize: sizeIcon }} /> Parceiro:
            </Key>

            <Value className="themeSLA">
              {ocorrencia?.parceiro ? maskCapitalized(ocorrencia?.parceiro) : 'Não informado'}
            </Value>
          </InfoContainer>

          <InfoContainer>
            <Key className="themeSLA">
              <UserOutlined style={{ color: colorIcon, fontSize: sizeIcon }} /> Embarcador:
            </Key>

            <Value className="themeSLA">
              {ocorrencia?.embarcador ? maskCapitalized(ocorrencia?.embarcador) : 'Não informado'}
            </Value>
          </InfoContainer>

          <InfoContainer>
            <Key className="themeSLA">
              <CopyOutlined style={{ color: colorIcon, fontSize: sizeIcon }} /> Notas:
            </Key>

            <Value className="themeSLA">
              {ocorrencia?.listaNf ? maskCapitalized(ocorrencia?.listaNf) : 'Sem nota(s)'}
            </Value>
          </InfoContainer>

          <InfoContainer>
            <Key className="themeSLA">
              <EnvironmentOutlined style={{ color: colorIcon, fontSize: sizeIcon }} /> Destino:
            </Key>

            <Value className="themeSLA">
              {ocorrencia?.cidade ? formatCyte(ocorrencia?.cidade) : 'Não informado'}
            </Value>
          </InfoContainer>

          <InfoContainer>
            <Key className="themeSLA">
              <CalendarOutlined style={{ color: colorIcon, fontSize: sizeIcon }} /> Criada em:
            </Key>

            <Value className="themeSLA">
              {ocorrencia?.dhAbertura
                ? moment(ocorrencia?.dhAbertura).format('llll')
                : 'Não informado'}
            </Value>
          </InfoContainer>

          <InfoContainer>
            <Key className="themeSLA">
              <CalendarOutlined style={{ color: colorIcon, fontSize: sizeIcon }} /> Finalizada em:
            </Key>

            <Value className="themeSLA" data-cy="dataFinalizada">
              {ocorrencia?.dhConclusao
                ? moment(ocorrencia?.dhConclusao).format('llll')
                : 'Em aberto'}
            </Value>
          </InfoContainer>

          <InfoContainer>
            <Key className="themeSLA">
              <MessageOutlined style={{ color: colorIcon, fontSize: sizeIcon }} /> Assunto:
            </Key>

            <Value className="themeSLA">
              {ocorrencia?.assunto ? maskCapitalized(ocorrencia?.assunto) : 'Não informado'}
            </Value>
          </InfoContainer>
        </Card>
      ) : (
        <>
          <Skeleton loading={load} active />
          <Skeleton loading={load} active />
          <Skeleton loading={load} active />
          <Skeleton loading={load} active />
        </>
      )}
    </Container>
  );
};

export default memo(App);
